import React from "react";
import { Flex, Text, useToast } from "@chakra-ui/react";
import ActiveAuditSummary from "../Audit/components/ActiveAuditSummary";
import CompletedAuditList from "../Audit/components/CompletedAuditList";
import AuditRequirementCard from "./components/Audit/AuditRequirementCard";
import { useGetAllAudit } from "../../../hooks/query";
import { showErrorToast } from "../../../utils";
import { useSelector } from "react-redux";
import LocalSpinner from "../../../components/LocalSpinner";
import useAirUserRoles from "../../../utils/AuthUtils";

const AuditDashboard = () => {
  const toast = useToast();
  const { isAuditor } = useAirUserRoles();

  const [auditData, setAuditData] = React.useState([]);

  const roundSelector = useSelector((state) => state.issbRound);

  const questionnaireId = roundSelector.selectedRound?.id;

  const { isLoading } = useGetAllAudit(questionnaireId, {
    onSuccess: (data) => {
      setAuditData(data);
    },
    onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0,
    staleTime: 0,
    enabled: true,
    refetchInterval: 5000,
  });

  return isLoading ? (
    <LocalSpinner />
  ) : (
    <Flex direction="column" gap={6}>
      {/*<AuditRequirementCard toReview={toReview} />*/}

      <Text color="whiteShade.500" fontSize="heading.s" fontWeight="700">
        Active Audits
      </Text>

      {auditData.filter((audit) => audit?.isActive).length === 0 ? (
        <Text color="gray.400" fontSize="body.s" mb={4}>
          No active audits at the moment
        </Text>
      ) : (
        auditData
          .filter((audit) => audit?.isActive)
          .map((audit) => <ActiveAuditSummary key={audit.id} auditData={audit} />)
      )}

      <CompletedAuditList auditList={auditData.filter((audit) => audit?.isActive === false)} />
    </Flex>
  );
};

export default AuditDashboard;
